import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from 'react-router-dom'

import { PATHS } from './constants'
import { ROUTES } from './routes'

export const router = createBrowserRouter(
  createRoutesFromElements([
    <Route key='root' path='/' element={<Navigate to={PATHS.LOGIN} replace />} />,
    ...ROUTES.map((route) => <Route key={route.path} path={route.path} element={route.element} />),
  ])
)
